import { Box } from '@mui/material';
import React from 'react';
import TableHeader from './TableHeader';
import { TableWrapperProps } from '../../../types/table';
import { sizeByBreakpoint } from '../../../utils/helper';

const TableWrapper = ({ children, headerChildren, sx, ...headerProps }: TableWrapperProps) => {
  return (
    <Box
      width="100%"
      sx={{
        paddingY: sizeByBreakpoint(2, 28),
        paddingX: sizeByBreakpoint(2, 22),
        borderRadius: '20px',
        border: 1,
        borderColor: (theme) => theme.palette.border.main,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...sx
      }}
    >
      <TableHeader {...headerProps}>{headerChildren}</TableHeader>
      {children}
    </Box>
  );
};

export default TableWrapper;
